<template>
  <div class="problem-wrap">
    <!-- <Tooltip :content="problemItem.depName" placement="bottom-start"> -->
    <div>
      <span :title="problemItem.depName" class="title">{{
        problemItem.depName
      }}</span>
    </div>

    <!-- </Tooltip> -->
    <Tooltip :content="problemItem.depName" placement="bottom-start">
      <div class="all">
        <span
          :style="{
            width: `${getpx(problemItem.toRectification)}px`,
            backgroundColor: '#f45f81',
          }"
        ></span>
        <span
          :style="{
            width: `${getpx(problemItem.toRecheck)}px`,
            backgroundColor: '#ffaf75',
          }"
        ></span>
        <span
          :style="{
            width: `${getpx(problemItem.toAppeal)}px`,
            backgroundColor: '#e85fff',
          }"
        ></span>
        <span
          :style="{
            width: `${getpx(problemItem.appealNotPass)}px`,
            backgroundColor: '#6d60ff',
          }"
        ></span>
        <span
          :style="{
            width: `${getpx(problemItem.toApproval)}px`,
            backgroundColor: '#f5db40',
          }"
        ></span>
        <span
          :style="{
            width: `${getpx(problemItem.appealPass)}px`,
            backgroundColor: '#16dfb0',
          }"
        ></span>
        <span
          :style="{
            width: `${getpx(problemItem.rectificationComplete)}px`,
            backgroundColor: '#9bec5e',
          }"
        ></span>
        <span
          :style="{
            width: `${getpx(problemItem.expired)}px`,
            backgroundColor: '#1A94E6',
          }"
        ></span>
      </div>
      <div slot="content">
        <p v-show="problemItem.toRectification > 0">
          {{ $t('common.status1') }}:{{ problemItem.toRectification }}
        </p>
        <p v-show="problemItem.toRecheck > 0">
          {{ $t('common.status2') }}:{{ problemItem.toRecheck }}
        </p>
        <p v-show="problemItem.toAppeal > 0">
          {{ $t('common.status3') }}:{{ problemItem.toAppeal }}
        </p>
        <p v-show="problemItem.appealNotPass > 0">
          {{ $t('common.status4') }}:{{ problemItem.appealNotPass }}
        </p>
        <p v-show="problemItem.toApproval > 0">
          {{ $t('common.status5') }}:{{ problemItem.toApproval }}
        </p>
        <p v-show="problemItem.appealPass > 0">
          {{ $t('common.status6') }}:{{ problemItem.appealPass }}
        </p>
        <p v-show="problemItem.rectificationComplete > 0">
          {{ $t('common.status7') }}:{{ problemItem.rectificationComplete }}
        </p>
        <p v-show="problemItem.expired > 0">
          {{ $t('common.status8') }}:{{ problemItem.expired }}
        </p>
      </div>
    </Tooltip>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },

  props: {
    problemItem: {
      type: Object,
    },
    maxProblem: {
      type: Number,
    },
  },
  computed: {
    total() {
      let a =
        this.problemItem.toRectification +
        this.problemItem.toRecheck +
        this.problemItem.toAppeal +
        this.problemItem.appealNotPass +
        this.problemItem.toApproval +
        this.problemItem.appealPass +
        this.problemItem.rectificationComplete +
        this.problemItem.expired;
      return a;
    },
  },
  methods: {
    getpx(item) {
      return (item / this.total) * 190 * (this.total / this.maxProblem);
    },
  },
  // watch: {
  //   problemItem(newVal) {
  //     let total =
  //       newVal.toRectification +
  //       problemItem.toRecheck +
  //       problemItem.toAppeal +
  //       problemItem.appealNotPass +
  //       problemItem.toApproval +
  //       problemItem.appealPass +
  //       problemItem.rectificationComplete;
  //     this.per = 190 / total;
  //     console.log('aaaafff',per);
  //   },
  // },
};
</script>
<style lang="less" scoped>
.problem-wrap {
  height: 40px;
  width: 240px;
  .title {
    font-size: 12px;
    display: inline-block;
    width: 180px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .all {
    height: 10px;
    display: flex;
    span {
      display: inline-block;
      height: 100%;
      background-color: #bfa;
      cursor: pointer;
    }
  }
}
</style>
